<mat-icon *ngIf="!plain()" class="xp-message__icon">{{ shownIcon() }}</mat-icon>
<span class="xp-message__text"><ng-content></ng-content></span>
